// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingSectionScrollViewPageSectionEvent
 */
export var MarketingSectionScrollViewPageSection = function (_a) {
    var sectionName = _a.sectionName;
    return ({
        name: "MarketingSection Scroll ViewPageSection",
        parameters: {
            cdf_entity: "MarketingSection",
            cdf_action: "Scroll",
            section_name: sectionName !== undefined && sectionName !== null ? sectionName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
